// Qué cajas se le pueden ofrecer a un usuario al abrir caja.
//
// Vive fuera del formulario para poder probarse: importar el componente arrastra
// la librería de interfaz, que hoy el ejecutor de pruebas no transforma.
const normalizar = (texto) => (texto || "").toString().replace(/\s+/g, "").toUpperCase();

// Un usuario no-administrador solo debe ver las cajas de su Tienda/Grupo
// asignado (dato que llega de BC, ver UserForm.js). La Tienda se cruza por
// `caja.TPV` (código exacto, ej. "MALL DEL SOL" -- mismo valor que `tpv.No`
// y que el propio campo Tienda de BC, confirmado consultando en vivo el
// registro real de un empleado) -- NO por `caja.tpvNombre`, que en los datos
// reales queda igual a `caja.nombre` (bug de sincronización ajeno a este
// filtro, no el nombre de la tienda). El Grupo se cruza de forma
// normalizada contra `caja.nombre` porque el texto que llega de BC no
// siempre coincide con el mismo espaciado (ej. Grupo "CC LA Y" vs. caja
// "CAJA 1 CCLAY"); si esa comparación no encuentra ninguna caja (por texto
// que no siga ese patrón), se prioriza el filtro por tienda -- que sí usa un
// código exacto -- antes que dejar al cajero sin ninguna caja para abrir.
export const filtrarCajasPorUsuario = (cajas, currentUser) => {
  if (!currentUser?.Tienda) return cajas;

  const porTienda = cajas.filter((caja) => caja.TPV === currentUser.Tienda);

  // El recorte por tienda vale también para un supervisor, y no es una cuestión
  // de permisos sino de la clave de Business Central: allá un cajero se
  // identifica por (Tienda, No). Ofrecerle a SUPEXC --que es de MALL DEL SOL--
  // una caja de PVLAY produce una apertura que BC rechaza con "No existe el
  // cajero SUPEXC en la tienda PVLAY". Antes el supervisor las veía todas por
  // ser Admin, así que se podía elegir una combinación imposible y el aviso
  // llegaba recién al sincronizar. Del grupo sí queda libre: dentro de su
  // tienda, un supervisor abre cualquier caja.
  if (currentUser?.Admin) return porTienda;

  if (!currentUser?.Grupo) return porTienda;

  const grupoNormalizado = normalizar(currentUser.Grupo);
  const porGrupo = porTienda.filter((caja) => normalizar(caja.nombre).includes(grupoNormalizado));

  return porGrupo.length > 0 ? porGrupo : porTienda;
};


/**
 * Las tiendas que un usuario puede consultar en Traer Históricos.
 *
 * No es la misma regla que la de abrir caja, y la diferencia es deliberada:
 *
 * - **Abrir caja** recorta por tienda a todos, supervisor incluido, porque
 *   Business Central identifica al cajero por (Tienda, No) y una apertura en
 *   otra tienda la rechaza. Ahí el recorte evita crear algo imposible.
 * - **Traer Históricos** sólo lee. No hay nada que BC pueda rechazar, así que
 *   el supervisor la usa global --necesita revisar cualquier tienda-- y el
 *   cajero queda en la suya.
 *
 * Si el usuario no tiene tienda asignada no hay con qué recortar y las ve
 * todas. Si la tiene y no aparece entre las sincronizadas, la lista queda
 * vacía a propósito: es una restricción, y aflojarla ante un dato faltante la
 * volvería inútil justo cuando importa.
 */
export const filtrarTiendasPorUsuario = (tpvs, currentUser) => {
  if (currentUser?.Admin) return tpvs;
  if (!currentUser?.Tienda) return tpvs;

  return tpvs.filter((tpv) => tpv.No === currentUser.Tienda);
};
